<template>
     <div class="discover">
            <div class="loading">
          <div class="container">
            <span class="girl"></span>
            <div class="boys">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
      </div>
        <header>
          <h1 v-for="item in book_type">{{item.bt_name}}</h1>
        </header>
        <div class="dis-container">
          <!-- swipe -->
          <div class="dis_a">
            <mt-swipe :auto="4000">
              <mt-swipe-item v-for="(item,index) in book_loop" :key="index">
                <img :src="'http://ts.winwulian.com/uploads/looppic'+'/'+item.pic" class="dis_imga">
              </mt-swipe-item>
            </mt-swipe>
          </div>
          <div class="diats"></div>
          <!-- listen -->
          <div class="listen_a">
            <ul>
              <!-- 1 -->
              <li v-for="item in book_list" @click="bookx(item.b_id,item.b_is_video)">
                  <div class="listen_imga">
                    <img :src="'http://ts.winwulian.com/uploads/booklistphoto'+'/'+item.b_pic">
                  </div>
                  <div class="listen_imgb">
                    <p class="listen_pa">{{item.b_bookname}}</p>
                    <p v-if="item.b_author != '' && item.b_author != null">作者：<span>{{item.b_author}}</span></p>
                    <p v-if="item.b_readuser != '' && item.b_readuser != null">朗读：<span>{{item.b_readuser}}</span></p>
                    <p v-if="item.b_genre != '' && item.b_genre!= null">体载：<span>{{item.b_genre}}</span></p>
                    <p v-if="item.b_people != '' && item.b_people != null">适合人群：<span>{{item.b_people}}</span></p>
                    <p><span>{{item.money}}{{item.b_price}}</span>&nbsp;&nbsp;&nbsp;
                    <v-icon :name="item.iocn" class="dis_bell"></v-icon>
                    <span>{{item.b_playnum}}</span>
                    </p>
                  </div>
              </li>
              <!-- 2 -->
            
              <!-- end -->
            </ul>
          </div>
        </div>
        <div class="appNav">
            <ul>
                <router-link to="/">
                <li class="home">
                    <v-icon name="home" class="hv"></v-icon>
                    <p class="hp">首页</p>
                </li>
                </router-link>
                <router-link to="/discover/all">
                <li class="globe cccc">
                    <v-icon name="globe" class="gv"></v-icon>
                    <p class="gp">专辑</p>
                </li>
                </router-link>
                <router-link to="/activity">
                <li class="comments">
                    <v-icon name="comments" class="cv"></v-icon>
                    <p class="cp">活动</p>
                </li>
                </router-link>
                <router-link to="/mine">
                <li class="user">
                    <v-icon name="user" class="uv"></v-icon>
                    <p class="up">个人</p>
                </li>
                </router-link>
            </ul>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import { CURL } from "../../lib/url.js";
export default {
   data() {
      return {
        params: '',
        book_list:[],
        book_loop:[],
        book_type:[]
      }
    },
    created(){
      var param = this.$route.params.id;
      this.params = param
      },
  mounted(){
  setTimeout(function(){
    $('.loading').remove()
  },700)
  this.getAjax();
  var ii=0;
  $('.search_span').click(function(){
    ii++;
    var jj =ii % 2
    if(jj == 0){
      $('.search_none').fadeOut()
    }else{
      $('.search_none').fadeIn()
    }
    $('.search_nep1').click(function(){
      var search_nep1=$('.search_nep1').text()
      $('.search_none').fadeOut()
      $('.qb_xxxx').text(search_nep1)
    });
    $('.search_nep2').click(function(){
      var search_nep2=$('.search_nep2').text()
      $('.search_none').fadeOut()
      $('.qb_xxxx').text(search_nep2)
    });
    $('.search_nep3').click(function(){
      var search_nep3=$('.search_nep3').text()
      $('.search_none').fadeOut()
      $('.qb_xxxx').text(search_nep3)
    });
  })
  },
methods:{
  bookx:function(e,j){
    if(j == 2){
//    location.href = '/discover/discont/'+e
      this.$router.push({path:'/discover/discont/'+e})
      // volume-up 音频
    }else{
//    location.href = '/video/disv/'+e
      this.$router.push({path:'/video/disv/'+e})
      // tv 视频
    }
  },
  getAjax:function () {
   var successCallback =  (response) => {
      if(response.booklist.length == 0){
        var dele=$('.listen_a')
        dele.empty()
      }
      for(var i=0;i<response.booklist.length;i++){
        if(response.booklist[i].b_price == '0' || response.booklist[i].b_price == '0.00'){
          response.booklist[i]['b_price']='免费'
        }else{
          response.booklist[i]['money']='￥'
        }
      }
      if(response){
        for(var i=0;i<response.booklist.length;i++){
          if(response.booklist[i].b_is_video != '1'){
            response.booklist[i]["iocn"] = 'volume-up'
          }else{
            response.booklist[i]["iocn"] = 'tv'
          }
        }
        this.book_list = response.booklist
        this.book_type = response.type
        this.book_loop = response.looppic
      }
    }
    var errorCallback =  (response) => {
        console.log('服务器请求出错了')
    }
    this.$http.get(CURL+'/portal/All/getbooklist?id='+this.$route.params.id,{
      data:{}
    }).then(successCallback,errorCallback);
  }
}

          
};



</script>

<style lang="scss" scoped>

/*tap*/
.appNav {
  width: 100%;
  height: 0.6rem;
  border-top: 0.01rem solid #f2f2f2;
  background: #ffffff;
  position: fixed;
  bottom:0;
  ul,
  li{
    list-style: none;
  }
  ul{
    li{
        float: left;
        width: 25%;
        text-align: center;
    }
  }
}
.hv,.gv,.cv,.uv{
  margin-top: .13rem;
}
.cccc{
  color: #4eb1d3!important;
}
/*tap*/

/**/
.diats{
  width: 95%;
  margin: 10px auto;
  background: #00afdb;
  height: 2px;
}
/*loading*/
.container {
    margin-top: 50%;
    margin-left:18%; 
    width: 55%;
    height: 1em;
    font-size: 35px;
    display: flex;
    justify-content: space-between;
}

.container span {
    width: 15px;
    height: 15px;
    --duration: 1.5s;
}

.girl {
    animation: slide var(--duration) ease-in-out infinite alternate;
}

@keyframes slide {
    from {
        transform: translateX(0);
        filter: brightness(1);
    }

    to {
        transform: translatex(calc(8em - (1em * 1.25)));
        filter: brightness(1.45);
    }
}

.boys {
    width: 65%;
    display: flex;
    justify-content: space-between;
}

.boys span {
    animation: var(--duration) ease-in-out infinite alternate;
}

.boys span:nth-child(1) {
    animation-name: jump-off-1;
}

.boys span:nth-child(2) {
    animation-name: jump-off-2;
}

.boys span:nth-child(3) {
    animation-name: jump-off-3;
}

.boys span:nth-child(4) {
    animation-name: jump-off-4;
}

@keyframes jump-off-1 {
    0%, 15% {
        transform: rotate(0deg);
    }

    35%, 100% {
        transform-origin: -50% center;
        transform: rotate(-180deg);
    }
}

@keyframes jump-off-2 {
    0%, 30% {
        transform: rotate(0deg);
    }

    50%, 100% {
        transform-origin: -50% center;
        transform: rotate(-180deg);
    }
}

@keyframes jump-off-3 {
    0%, 45% {
        transform: rotate(0deg);
    }

    65%, 100% {
        transform-origin: -50% center;
        transform: rotate(-180deg);
    }
}

@keyframes jump-off-4 {
    0%, 60% {
        transform: rotate(0deg);
    }

    80%, 100% {
        transform-origin: -50% center;
        transform: rotate(-180deg);
    }
}

.container span::before {    
    content: '';
    position: absolute;
    width: inherit;
    height: inherit;
    border-radius: 15%;
    box-shadow: 0 0 0.1em rgba(0, 0, 0, 0.3);
}

.girl::before {
    background-color: #7988da;
}

.boys span::before {
    background-color: dodgerblue;
    animation: var(--duration) ease-in-out infinite alternate;
}

.boys span:nth-child(1)::before {
    filter: brightness(1);
    animation-name: jump-down-1;
}

.boys span:nth-child(2)::before {
    filter: brightness(1.15);
    animation-name: jump-down-2;
}

.boys span:nth-child(3)::before {
    filter: brightness(1.3);
    animation-name: jump-down-3;
}

.boys span:nth-child(4)::before {
    filter: brightness(1.45);
    animation-name: jump-down-4;
}

@keyframes jump-down-1 {
    5% {
        transform: scale(1, 1);
    }

    15% {
        transform-origin: center bottom;
        transform: scale(1.3, 0.7);
    }

    20%, 25% {
        transform-origin: center bottom;
        transform: scale(0.8, 1.4);
    }

    40% {
        transform-origin: center top;
        transform: scale(1.3, 0.7);
    }

    55%, 100% {
        transform: scale(1, 1);
    }
}

@keyframes jump-down-2 {
    20% {
        transform: scale(1, 1);
    }

    30% {
        transform-origin: center bottom;
        transform: scale(1.3, 0.7);
    }

    35%, 40% {
        transform-origin: center bottom;
        transform: scale(0.8, 1.4);
    }

    55% {
        transform-origin: center top;
        transform: scale(1.3, 0.7);
    }

    70%, 100% {
        transform: scale(1, 1);
    }
}

@keyframes jump-down-3 {
    35% {
        transform: scale(1, 1);
    }

    45% {
        transform-origin: center bottom;
        transform: scale(1.3, 0.7);
    }

    50%, 55% {
        transform-origin: center bottom;
        transform: scale(0.8, 1.4);
    }

    70% {
        transform-origin: center top;
        transform: scale(1.3, 0.7);
    }

    85%, 100% {
        transform: scale(1, 1);
    }
}

@keyframes jump-down-4 {
    50% {
        transform: scale(1, 1);
    }

    60% {
        transform-origin: center bottom;
        transform: scale(1.3, 0.7);
    }

    65%, 70% {
        transform-origin: center bottom;
        transform: scale(0.8, 1.4);
    }

    85% {
        transform-origin: center top;
        transform: scale(1.3, 0.7);
    }

    100%, 100% {
        transform: scale(1, 1);
    }
}

.loading{
  background-color:#00a8d9;
  position:fixed;
  z-index:999999;
  top:0;
  left:0;
  width:100%;
  height:100%;
  text-align:center;
  line-height:300px;
  padding-top: 35%;
  padding-left: 5%;
  padding-right: 5%;
}
/**/
.search_nep3{
  margin-top: 20px;
  margin-bottom: 20px;
}
.search_nep1{
  margin-top: 15px;
  margin-bottom: 18px;
}
.search_none{
  display: none;
  position: absolute;
  background-color: #FFFFFF;
  top: 206px;
  left: 5%;
  border-radius: 5px;
  p{
    padding-left: 8px;
    padding-right: 23px;
    font-size: 13px;
    color: #333;
  }
}
/**/
.listen_pa{
  color: #000!important;
  font-size: 14px;
  font-weight: bold;
}
.listen_imgb{
  width: 70%;
  float: left;
  margin-top: 13px;
  margin-left: 10px;
  margin-bottom: 10px;
}
.listen_imgb p{
  margin-bottom: 3px;
  color: #000;
}
.listen_imga{
  width: 20%;
  margin-left: 2%;
  margin-right: 2%;
  float: left;
  margin-top: 10px;
  margin-bottom: 10px;
}
.listen_imga img{
  width: 100%;
  height: 110px;
}
.listen_a{
  width: 100%;
  float: left;
  ul{
    width: 100%;
    float: left;
    margin-bottom: 0.6rem;
    li{
      float: left;
      width: 100%;
      border-bottom: #ccc solid 1px;
    }
  }
}
.clockb{
  color: #999;
  margin-left: 5px;
}
.discover {
  display: flex;
  flex-direction: column;
  height: auto;
}
.dis-container {
  flex: 1;
}
header{
  width: 100%;
  height: .4rem;
  background:url(../../img/ss.png);
  background-size:100% 100%;
  background-repeat: no-repeat;
  float: left;
  position: fixed;
  z-index: 999;
  h1{
    margin-top: .2rem;
    height: 95%;
    line-height: 0px;
    text-align: center;
    font-size: 19px;
    font-weight: 600;
    color: #FFFFFF;
  }
}

.dis_imga{
  width: 100%!important;
  height: auto;
}
.dis_a{
  margin-top: .45rem;
  height: 130px;
  width: 100%;
}
.dis_b{
  width: 100%;
  height: 50px;
  background-color: #00a8d9;
}
.search_div{
  height: 33px;
  width: 80%;
  background-color: #FFFFFF;
  float: left;
  margin-left: 5%;
  border-radius: 8px;
  margin-top: 8px;
  line-height: 40px;
}
.input-kw{
  margin-bottom: 8px;
  width: 65%;
  height: 30px;
  background-color: transparent;
  border:0;
}
.input_i{
  color: #FFFFFF;
  font-size: 16px;
  float: left;
  margin-top: 13px;
  margin-left: 5px;
}
.search_span{
  margin-left: 3%;
  background-color: #FFFFFF;
  border-right: #ccc solid 1px;
  padding-right: 5px;
  color: #87ceeb;
  font-size: 14px;
}
#input-test::-webkit-input-placeholder{
  font-size: 14px;
  color: #999;
}
.dis_bell{
  width: 10px;
  padding-top: 5px;
  color: #4eb1d3;
}
</style>



// WEBPACK FOOTER //
// src/components/discover/index.vue